/**
 * User notification settings service — addresses and per-priority preferences
 */
import api from './api'
import type { UserNotificationAddress, UserNotificationPref } from '../types'

// ===== Notification Addresses =====

export async function listNotificationAddresses(): Promise<UserNotificationAddress[]> {
  const response = await api.get<UserNotificationAddress[]>('/v1/users/me/notification-addresses')
  return response.data
}

export async function addNotificationAddress(data: {
  channel: string
  address: string
  label: string
}): Promise<UserNotificationAddress> {
  const response = await api.post<UserNotificationAddress>('/v1/users/me/notification-addresses', data)
  return response.data
}

export async function updateNotificationAddress(
  id: number,
  data: { label?: string; is_active?: boolean }
): Promise<UserNotificationAddress> {
  const response = await api.patch<UserNotificationAddress>(
    `/v1/users/me/notification-addresses/${id}`,
    data
  )
  return response.data
}

export async function deleteNotificationAddress(id: number): Promise<void> {
  await api.delete(`/v1/users/me/notification-addresses/${id}`)
}

// ===== Notification Preferences =====

export async function listNotificationPrefs(): Promise<UserNotificationPref[]> {
  const response = await api.get<UserNotificationPref[]>('/v1/users/me/notification-prefs')
  return response.data
}

export async function updateNotificationPref(
  priority: string,
  data: {
    channels?: string[]
    advance_minutes?: number | null
    notify_when_overdue?: boolean
  }
): Promise<UserNotificationPref> {
  const response = await api.patch<UserNotificationPref>(
    `/v1/users/me/notification-prefs/${priority}`,
    data
  )
  return response.data
}
